import {PlayClass} from "../generic/PlayClass";

// TODO: Could improve this by adding sub classes
export class ConsolidationClass extends PlayClass {

  public areRequiredClassesCompleted(): boolean {
    return this.requiredClasses.length === 0 || this.requiredClasses.every(value => value.progress.isFinished);
  }

  /**
   * On a regular class we consider it available if required classes are done,
   * here it's a bit different since we don't want user to add one part at the time, so we have two cases :
   * - Class is Advised (refer to isAdvised documentation)
   * - Both contained classes are done meaning also all required class are done
   */
  public isAvailable(): boolean {
    return this.areRequiredClassesCompleted()
      && (this.isAdvised() || this.containedClasses.every(value => value.progress.isFinished))
  }

  /**
   * We advise class if all requiredClasses are done and if :
   * - at least one of the two contained classes are good, which mean that user only as one part to add to the consolidation
   * - If there is no contained classes which mead we are on the first consolidation classes
   */
  public isAdvised(): boolean {
    if (this.areRequiredClassesCompleted()) {
      if (this.containedClasses.length === 0) {
        return true;
      }
      else {
        return this.containedClasses[0].progress.isFinished || this.containedClasses[1].progress.isFinished
      }
    }
    return false;
  }

  public hasAtLeaseOneClassAvailableAndNotFinished(): boolean {
    return true;
  }
}
